import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PresenceService } from 'app/common/services/presence.service';
import { NavLogService } from 'app/common/services/nav-log.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor(presence: PresenceService, navLog: NavLogService)
    {
        presence.start();
        navLog.start();
    }
}
